const t=async(t,a,e=()=>{})=>{let l;try{e(!0),l=await t(...a)}finally{e(!1)}return l};export{t as default};
//# sourceMappingURL=callActionAsync.js.map
